import { render } from "./Funders.vue?vue&type=template&id=535f0946"
import script from "./Funders.vue?vue&type=script&lang=js"
export * from "./Funders.vue?vue&type=script&lang=js"

import "./Funders.vue?vue&type=style&index=0&id=535f0946&lang=css"
script.render = render

export default script